import { render, staticRenderFns } from "./IndexLogoHome.vue?vue&type=template&id=6fb665a2&scoped=true"
import script from "./IndexLogoHome.vue?vue&type=script&lang=js"
export * from "./IndexLogoHome.vue?vue&type=script&lang=js"
import style0 from "./IndexLogoHome.vue?vue&type=style&index=0&id=6fb665a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb665a2",
  null
  
)

export default component.exports